/**
 * Theme metadata that can't be expressed as CSS variables (e.g. <video src>, <img src>).
 *
 * Selected by VITE_THEME at build time, same as the CSS token theme.
 */

export const THEME_META = {
  default: {
    brandLogo: {
      topText: "San Antonio",
      mainText: "The Boss Brief",
    },
    homeHero: {
      // 'video' or 'image'
      kind: "video",
      // For kind === 'video': URL to mp4/webm (currently mp4)
      // For kind === 'image': URL to image asset
      src: "https://d2oa23hr7q6t96.cloudfront.net/base/home-vid-rev2.mp4",
      // Optional poster image for video
      poster: undefined,
    },
  },
  sanantonio: {
    brandLogo: {
      topText: "San Antonio",
      mainText: "The Boss Brief",
    },
    homeHero: {
      // 'video' or 'image'
      kind: "image",
      // For kind === 'video': URL to mp4/webm (currently mp4)
      // For kind === 'image': URL to image asset
      src: "https://d2oa23hr7q6t96.cloudfront.net/reports/6911a38f877c0a5d47903442/i/cffc46a330aeca5a950e45575427f02abbc856340121fbb19d3b01ae8ecd2751.png",
      // src: "https://d2oa23hr7q6t96.cloudfront.net/media/tbbhomemedia.mp4",
      // Optional poster image for video
      poster: undefined,
    },
  },
};

export function getSelectedThemeName() {
  return import.meta.env.VITE_THEME || "default";
}

export function getThemeMeta(themeName = getSelectedThemeName()) {
  const base = THEME_META.default || {};
  const theme = THEME_META[themeName] || {};

  // Merge defaults with theme overrides so missing fields (e.g. homeHero) still work.
  return {
    ...base,
    ...theme,
    brandLogo: {
      ...(base.brandLogo || {}),
      ...(theme.brandLogo || {}),
    },
    homeHero: {
      ...(base.homeHero || {}),
      ...(theme.homeHero || {}),
    },
  };
}
